import { render, staticRenderFns } from "./transActionList.vue?vue&type=template&id=0ad6906b"
import script from "./transActionList.vue?vue&type=script&lang=js"
export * from "./transActionList.vue?vue&type=script&lang=js"
import style0 from "./transActionList.vue?vue&type=style&index=0&id=0ad6906b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports